import { z } from 'zod';

import type { useTranslations } from 'next-intl';

import { emailSchema } from '~/constants';

export function contactUsSchema(t: ReturnType<typeof useTranslations>) {
  return z.object({
    fullName: z.string().min(
      1,
      t('validations.required', {
        field: t('models.contactUs.fields.fullName'),
      }),
    ),
    email: emailSchema(t),
    phoneNumber: z.string(),
    message: z.string().min(
      1,
      t('validations.required', {
        field: t('models.contactUs.fields.description'),
      }),
    ),
  });
}
